import Theme from '@adsk/alloy-react-theme';

export const noPurchasedProductsTextStyle = {
  ...Theme.typography.bodySmall,
  color: Theme.colors.charcoal500,
};

export const productsLabelStyle = {
  display: 'flex',
  paddingBottom: '5px',
  alignItems: 'center',
  color: Theme.colors.charcoal900,
  ...Theme.typography.bodyMediumBold,
};

export const tooltipIconStyle = {
  marginLeft: '5px',
  color: Theme.colors.charcoal700,
};

export const fieldStyle = {
  paddingTop: '20px',
  width: '100%',
};
